import * as actionTypes from "../actionTypes/Index";
import { bannerInitialState } from "./InitialState";
import { IActionType } from "../../interfaces/Index";

const initialState = { ...bannerInitialState };

export default function bannerReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.GET_BANNERS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isBannerFetched: false,
        isBannerAndProductsUpdated: false,
        isBannerSequenceUpdated: false,
        banner: [],
        error: null,
      });
    }
    case actionTypes.GET_BANNERS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isBannerFetched: true,
        banner: (action.payload as any).slice(),
      });
    }
    case actionTypes.GET_BANNERS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isBannerFetched: false,
        banner: [],
        error: action.error,
      });
    }
    case actionTypes.UPDATE_BANNER_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isBannerAndProductsUpdated: false,
      });
    }
    case actionTypes.UPDATE_BANNER_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        error: null,
        isBannerAndProductsUpdated: true,
      });
    }
    case actionTypes.UPDATE_BANNER_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        isBannerAndProductsUpdated: false,
      });
    }
    case actionTypes.UPDATE_BANNER_AND_PRODUCT_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isBannerAndProductsUpdated: false,
        error: null,
      });
    }
    case actionTypes.UPDATE_BANNER_AND_PRODUCT_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isBannerAndProductsUpdated: true,
        isError: false,
      });
    }
    case actionTypes.UPDATE_BANNER_AND_PRODUCT_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isBannerAndProductsUpdated: false,
        error: action.error,
      });
    }
    case actionTypes.UPDATE_BANNER_SEQUENCE_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isBannerSequenceUpdated: false,
        error: null,
      });
    }
    case actionTypes.UPDATE_BANNER_SEQUENCE_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isBannerSequenceUpdated: true,
      });
    }
    case actionTypes.UPDATE_BANNER_SEQUENCE_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isBannerSequenceUpdated: false,
        isError: true,
        error: action.error,
      });
    }
    default:
      return state;
  }
}
